export default "__VITE_ASSET__dO26PIGC__"